export const BYU_OR_TSEL_NUMBER_PREFIX = [
  "0811",
  "0812",
  "0813",
  "0821",
  "0822",
  "0823",
  "0851",
  "0852",
  "0853",
];
